{
  "app": {
    "title": "Facturering",
    "close_button": "Sluiten",
    "loading": "Laden..."
  },
  "orders_dashboard": {
    "title": "Orders",
    "filter_all": "Alle",
    "filter_unassigned": "Niet toegewezen",
    "filter_expiring": "Verloopt",
    "filter_undeployed": "Beschikbaar om uit te rollen",
    "filter_canActivate": "Beschikbaar om te activeren",
    "search_orders": "Zoek bestellingen"
  },
  "orders_list": {
    "subscriptionExpiry": "VERVALDATUM ABONNEMENT",
    "end_of_orders_list": "einde van bestellingenlijst",
    "orderDate": "BESTELDATUM",
    "orderNumber": "BESTELNUMMER",
    "subscriptionNumber": "ABONNEMENTSNUMMER",
    "accountName": "TOEGEWEZEN ACCOUNT",
    "unassigned": "Niet toegewezen",
    "unavailable": "Niet beschikbaar",
    "expiring": "VERLOOPT SPOEDIG",
    "assign": "TOEWIJZEN",
    "expired": "VERLOPEN",
    "perpetual": "EEUWIGDUREND",
    "pending": "WACHT OP ACTIVATIE",
    "error_retrieving_orders": "Er was een fout bij het ophalen van de bestellingen.",
    "no_orders_found": "Geen bestellingen gevonden.",
    "deploy": "Implementeren",
    "activate": "Activeren"
  },
  "order_details": {
    "deploy_button": "Implementeren",
    "activate_button": "Activeren",
    "assign_button": "Toewijzen",
    "order_number": "Bestelling #",
    "tracking_number": "Trackingnummer",
    "subscription_number": "Abonnement #",
    "see_additional_details": "Zie additionele trackingdetails",
    "hide_additional_details": "Vouw additionele trackingdetails in",
    "po_number": "Tussenpersoon PO-nummer",
    "reseller_SAP_Id": "reseller SAP ID",
    "sapOrderId": "SAP-bestelling-ID",
    "order_assigned_to": "Bestelling toegewezen aan",
    "start_date": "Begindatum",
    "term": "Term",
    "please_pick_acct_msg": "We konden geen overeenkomst met deze bestelling vinden, dus selecteer handmatig een account waarop deze van toepassing is.",
    "company": "Bedrijf",
    "create_new_account": "Maak nieuw account aan",
    "order_expiry_time": "BESTELLING ZAL VERLOPEN IN {{numdays}} DAGEN",
    "licenses": "Licenties",
    "license": "Licentie",
    "customerSapId": "SAP ID van klant",
    "customerPONumber": "PO-nummer van klant",
    "search_companies": "Zoek bedrijven",
    "month": "Maand",
    "year": "Jaar",
    "day": "Dag",
    "unknown": "Onbekend",
    "assigning_account_to_order": "Bestelling toewijzen aan account...",
    "deploying_order": "Bestelling wordt geïmplementeerd...",
    "activating_order": "Bestelling wordt geactiveerd...",
    "error_assigning_order": "Er was een fout bij het toewijzen van de bestelling aan een account.",
    "error_deploying_order": "Er was een fout bij het implementeren van de bestelling.",
    "error_activating_order": "Er was een fout bij het activeren van de bestelling.",
    "cannot_comm_parent": "We kunnen u niet terugsturen naar het juiste formulier. U kunt account aanmaken vanuit de Accounts app.",
    "no_results_found": "Geen resultaten gevonden",
    "existing-subscription": "Toewijzing mislukt: dit bedrijf heeft al een bestelling.",
    "0001": "Onvoldoende licenties. Het aantal toegewezen gratis licenties ({free}) overschrijdt het aantal licenties ({paid}) in de betaalde bestelling.",
    "restricted_view_warning": "Functies uitgeschakeld. Uw toegang is beperkt."
  },
  "order_complete": {
    "go-to-account-integrations": "Ga naar accountintegraties",
    "go-to-account": "Ga naar account",
    "activate-order": "Bestelling activeren",
    "order-added": "Bestelling toegevoegd!",
    "order-deployed": "Bestelling geïmplementeerd!",
    "order-activated": "Bestelling geactiveerd!",
    "enable-integration": "Let wel, de items in deze bestelling vereisen een integratie die moet zijn ingesteld en ingeschakeld om te kunnen werken.",
    "activate-order-instructions": "Even een opmerking: deze bestelling moet geactiveerd worden om te werken."
  },
  "errors": {
    "504-general-message": "De oplossing is druk of niet bereikbaar. Probeer het opnieuw.",
    "couldnt-find-order": "We konden de bestelling niet in de lijst vinden. Probeer de pagina opnieuw te laden."
  }
}